export type OfferRequestDetailSearch = { contact?: true };

// The mobile contact/chat screen is a search param rather than a child route so that one detail
// route serves both breakpoints: at md and up the param is ignored, and the browser's back button
// leaves the screen instead of the page.
export function validateOfferRequestDetailSearch(search: Record<string, unknown>): OfferRequestDetailSearch {
    return search.contact === true || search.contact === 'true' ? { contact: true } : {};
}
